module.exports = __webpack_public_path__ + "static/media/share_lab.43ed18f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/share_lab.png
// module id = 445
// module chunks = 0